import React from 'react'
import PropTypes from 'prop-types'
import { Header } from 'components/patterns/Typography'
import LogicSetEvaluationBanner from 'components/feature/Simulation/LogicSetEvaluationBanner'
import { rungDisplayNames } from 'components/feature/NavigatorPanes/ConditionPane/ConditionEditor/ConditionEditor'
import ConditionSimulator from 'components/feature/Simulation/ConditionSimulator'
import OutputtingDataTo from 'components/feature/NavigatorPanes/OutputtingDataTo'

const SingleConditionSimulator = (props) => {
  const { parentType, subType, evaluationResult, uri } = props

  const displayName = rungDisplayNames(parentType, subType, 0)
  return (
    <>
      <Header type="h3">{displayName}</Header>
      <LogicSetEvaluationBanner evaluation={evaluationResult} />
      <div>
        <ConditionSimulator uri={uri} />
      </div>
      <OutputtingDataTo uri={uri} />
    </>
  )
}

SingleConditionSimulator.propTypes = {
  parentType: PropTypes.string,
  subType: PropTypes.string,
  evaluationResult: PropTypes.bool,
  uri: PropTypes.string,
}

export default SingleConditionSimulator
